import { RelativeDateBuilder } from '../RelativeDateBuilder';
import { isRelativeDate } from './date-value-utils';
import type { DateOperatorInputProps } from './types';

export function RelativeDateInput({ value, onChange, disabled }: DateOperatorInputProps) {
  const relative = isRelativeDate(value) ? value : null;

  return <RelativeDateBuilder value={relative} onChange={rel => onChange([rel])} disabled={disabled} />;
}
